/**
 * The parameter adds extra scroll height at the very bottom of the document
 * (an actual spacer, not internal padding). This is intended for the in-app
 * webview, where the native bottom bar overlays the bottom of the page. With
 * a spacer at the end, the user can scroll the last bit of content above the
 * native bar.
 *
 * Examples:
 *   ?bottomSpacer=46px
 *   ?bottomSpacer=2rem
 */

export function applyBottomSpacer() {
  const urlParams = new URLSearchParams(window.location.search);
  const bottomSpacer = urlParams.get('bottomSpacer');

  if (!bottomSpacer) {
    return;
  }

  document.documentElement.style.setProperty('--bottom-spacer-height', `${bottomSpacer}`);
}



// WEBPACK FOOTER //
// /tmp/build_c2a4b37a/src/bottomSpacer.js